export const hasEventEnded = (startsAt: string, endsAt?: string) => {
  const currentDate = new Date().getTime();
  const startsAtTime = new Date(startsAt).getTime();
  // If endsAt is missing we calculate endsAt as startsAt + 3 hours
  const endsAtTime = endsAt
    ? new Date(endsAt).getTime()
    : new Date(startsAtTime + 3 * 60 * 60 * 1000).getTime();

  return endsAtTime - currentDate < 0;
};
